import React, { useState } from 'react';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import useSources from 'views/Sources/hooks/useSources';
import { useRootState } from 'store/StateProvider';
import { saveCustomerDetails } from 'store/slices/actions';
import { InputBaseStyled } from 'components/forms/Input/styles';
import { Button, FormControl } from '@material-ui/core';
import CalculateCreditBalanceDialog from 'components/Dialog/CalculateCreditBalanceDialog';
import { getCalculatedBalance, parseStringToFloat } from 'utils/utils';

const getDatesToDisplay = (lastUpdateDateBalanceCredits, firebirdData) => {
    const today = Math.round(new Date().getTime() / (1000 * 3600 * 24));
    const lastUpdated = lastUpdateDateBalanceCredits
        ? new Date(lastUpdateDateBalanceCredits * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
          })
        : '';
    const currentTermEnds =
        +firebirdData.daysRemainingCurrentTerm > 0
            ? new Date((today + +firebirdData.daysRemainingCurrentTerm) * 24 * 60 * 60 * 1000).toLocaleDateString(
                  'en-US',
                  {
                      month: 'short',
                      day: '2-digit',
                      year: 'numeric',
                  },
              )
            : '';
    return { lastUpdated, currentTermEnds };
};

const BalanceCredit = (): JSX.Element => {
    const {
        sourcesData: {
            customerDetails: { customerType, balanceCredits, firebirdData, lastUpdateDateBalanceCredits },
        },
    } = useRootState();
    const { dispatch } = useSources();
    const [showModal, setShowModal] = useState(false);
    if (customerType === 'New') {
        return null;
    }

    const { lastUpdated, currentTermEnds } = getDatesToDisplay(lastUpdateDateBalanceCredits, firebirdData);

    return (
        <>
            <div className="details-item qa-label-credit-balance-deficit">
                Credit {+balanceCredits < 0 ? 'Deficit' : 'Balance'}
            </div>
            <div className="details-item qa-calculate-credit-container">
                <FormControl variant="outlined">
                    <InputBaseStyled
                        name="balanceCredits"
                        style={{ width: '100px' }}
                        value={balanceCredits}
                        onChange={(e) => {
                            dispatch(
                                saveCustomerDetails({
                                    balanceCredits: parseStringToFloat(e.target.value),
                                    ignorePrepopulateCreditBalance: true,
                                    creditBalanceAddedUsing: 'manuallyFilled',
                                }),
                            );
                        }}
                        type="string"
                        disableUnderline
                    />
                </FormControl>
                <TooltipIcon
                    placement="right"
                    title="Enter negative value for credit deficit"
                    arrow
                    style={{ marginLeft: '10px' }}
                />
                <Button id="link-button" onClick={() => setShowModal(true)}>
                    Calculate Balance
                </Button>
                {showModal ? (
                    <CalculateCreditBalanceDialog onClose={() => setShowModal(false)} lastUpdated={lastUpdated} />
                ) : null}
            </div>
            {!!lastUpdateDateBalanceCredits &&
                balanceCredits === getCalculatedBalance(firebirdData, !!lastUpdateDateBalanceCredits) && (
                    <>
                        <div className="details-item" />
                        {currentTermEnds ? (
                            <div className="details-item last-updated-day-container">
                                (Balance to carry forward to next term. Current Term ends on {currentTermEnds})
                            </div>
                        ) : (
                            <div className="details-item last-updated-day-container">(Balance as on {lastUpdated})</div>
                        )}
                    </>
                )}
            {!lastUpdateDateBalanceCredits && (
                <>
                    <div className="details-item" />
                    <div className="details-item balance-credits-not-updated">
                        (Balance credits for current term is not updated)
                    </div>
                </>
            )}
        </>
    );
};

export default BalanceCredit;
